exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.flexcontainer-title{list-style:none;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%;max-width:1170px}[dir] .flexcontainer-title{padding:0;margin:0 auto}.cancel-title,.flexitem{width:100%}[dir] .cancel-title{margin-top:20px}[dir=ltr] .cancel-title{padding-right:30px}[dir=rtl] .cancel-title{padding-left:30px}@media (max-width:992px){[dir=ltr] .cancel-title{padding-right:15px}[dir=rtl] .cancel-title{padding-left:15px}}.cancel-title-copy{width:100%}[dir] .cancel-title-copy{margin-bottom:20px}@media (max-width:992px){[dir=ltr] .cancel-title-copy{padding-right:15px}[dir=rtl] .cancel-title-copy{padding-left:15px}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/title/title.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/title/title.component.scss
// module chunks = 0